import { VoipActionNames } from "../constants/actionTypes"
import { IVoipCallState } from "../interfaces/voipCall/IVoipCallState"

const init = (): IVoipCallState => {
	return {
		voipInstanceId: null,
		isVoipSessionActive: false,
		voipAuthToken: null,
		redialPayload: null,
		autoEndTimeout: null,
		voipUserDetails: null,
	}
}

export const voipCallReducter = (state = init(), action: any): IVoipCallState => {
	switch (action.type) {
		case VoipActionNames.SET_IS_VOIP_SESSION_ACTIVE:
			return {
				...state,
				isVoipSessionActive: action.payload,
			}
		case VoipActionNames.SET_VOIP_INSTANCE_ID:
			return {
				...state,
				voipInstanceId: action.payload,
			}
		case VoipActionNames.SET_VOIP_AUTH_TOKEN:
			return {
				...state,
				voipAuthToken: action.payload,
			}
		case VoipActionNames.SET_REDIAL_PAYLOAD:
			return {
				...state,
				redialPayload: action.payload,
			}
		case VoipActionNames.SET_AUTO_END_TIMEOUT:
			return {
				...state,
				autoEndTimeout: action.payload,
			}
		case VoipActionNames.SET_VOIP_USER_DATA:
			return {
				...state,
				voipUserDetails: action.payload,
			}
		default:
			return state
	}
}
